module.exports = "/_next/static/images/AddToWalletIcon-e0a652104263e0f17b21c4780b21b11f.svg";